//KunLoading1组件
import KunLoading1 from './kun_loading1/index'
//KunLoading2组件
import KunLoading2 from './kun_loading2/index'
//KunLoading3组件
import KunLoading3 from './kun_loading3/index'
//KunLoading4组件
import KunLoading4 from './kun_loading4/index'
//KunLoading5组件
import KunLoading5 from './kun_loading5/index'
//KunLoading6组件
import KunLoading6 from './kun_loading6/index'
//KunLoading7组件
import KunLoading7 from './kun_loading7/index'
//KunLoading8组件
import KunLoading8 from './kun_loading8/index'
//KunLoading9组件
import KunLoading9 from './kun_loading9/index'
//KunLoading10组件
import KunLoading10 from './kun_loading10/index'
//KunLoading11组件
import KunLoading11 from './kun_loading11/index'
//KunLoading12组件
import KunLoading12 from './kun_loading12/index'
//KunLoading13组件
import KunLoading13 from './kun_loading13/index'
//KunLoading14组件
import KunLoading14 from './kun_loading14/index'
//KunLoading15组件
import KunLoading15 from './kun_loading15/index'
//KunLoading16组件
import KunLoading16 from './kun_loading16/index'
//KunLoading17组件
import KunLoading17 from './kun_loading17/index'
//KunLoading18组件
import KunLoading18 from './kun_loading18/index'
//KunLoading19组件
import KunLoading19 from './kun_loading19/index'
//KunLoading20组件
import KunLoading20 from './kun_loading20/index'
//KunLoading21组件
import KunLoading21 from './kun_loading21/index'
//KunLoading22组件
import KunLoading22 from './kun_loading22/index'
//KunLoading23组件
import KunLoading23 from './kun_loading23/index'
//KunLoading24组件
import KunLoading24 from './kun_loading24/index'
//KunLoading25组件
import KunLoading25 from './kun_loading25/index'
//KunLoading26组件
import KunLoading26 from './kun_loading26/index'
//KunLoading27组件
import KunLoading27 from './kun_loading27/index'
//KunLoading28组件
import KunLoading28 from './kun_loading28/index'
//KunLoading29组件
import KunLoading29 from './kun_loading29/index'
//KunLoading30组件
import KunLoading30 from './kun_loading30/index'
//KunLoading31组件
import KunLoading31 from './kun_loading31/index'
//KunLoading32组件
import KunLoading32 from './kun_loading32/index'
//KunLoading33组件
import KunLoading33 from './kun_loading33/index'
//KunLoading34组件
import KunLoading34 from './kun_loading34/index'
//KunLoading35组件
import KunLoading35 from './kun_loading35/index'
//KunLoading36组件
import KunLoading36 from './kun_loading36/index'
//KunLoading37组件
import KunLoading37 from './kun_loading37/index'
//KunLoading38组件
import KunLoading38 from './kun_loading38/index'
//KunLoading39组件
import KunLoading39 from './kun_loading39/index'
//KunLoading40组件
import KunLoading40 from './kun_loading40/index';
//KunLoading41组件
import KunLoading41 from './kun_loading41/index';
//KunLoading42组件
import KunLoading42 from './kun_loading42/index';
//KunLoading43组件
import KunLoading43 from './kun_loading43/index';
//KunLoading44组件
import KunLoading44 from './kun_loading44/index';
//KunLoading45组件
import KunLoading45 from './kun_loading45/index';
//KunLoading46组件
import KunLoading46 from './kun_loading46/index';
//KunLoading47组件
import KunLoading47 from './kun_loading47/index';
//KunLoading48组件
import KunLoading48 from './kun_loading48/index';
//KunLoading49组件
import KunLoading49 from './kun_loading49/index';
//KunLoading50组件
import KunLoading50 from './kun_loading50/index';
//KunLoading51组件
import KunLoading51 from './kun_loading51/index';
//KunLoading52组件
import KunLoading52 from './kun_loading52/index';
//KunLoading53组件
import KunLoading53 from './kun_loading53/index';
//KunLoading54组件
import KunLoading54 from './kun_loading54/index';
//KunLoading55组件
import KunLoading55 from './kun_loading55/index';
//KunLoading56组件
import KunLoading56 from './kun_loading56/index';
//KunLoading57组件
import KunLoading57 from './kun_loading57/index';
//KunLoading58组件
import KunLoading58 from './kun_loading58/index';
//KunLoading59组件
import KunLoading59 from './kun_loading59/index';
//KunLoading60组件
import KunLoading60 from './kun_loading60/index';
//KunLoading61组件
import KunLoading61 from './kun_loading61/index';
//KunLoading62组件
import KunLoading62 from './kun_loading62/index';
//KunLoading63组件
import KunLoading63 from './kun_loading63/index';
//KunLoading64组件
import KunLoading64 from './kun_loading64/index';
//KunLoading65组件
import KunLoading65 from './kun_loading65/index';
//KunLoading66组件
import KunLoading66 from './kun_loading66/index';
//KunLoading67组件
import KunLoading67 from './kun_loading67/index';
//KunLoading68组件
import KunLoading68 from './kun_loading68/index';
//KunLoading69组件
import KunLoading69 from './kun_loading69/index';
//KunLoading70组件
import KunLoading70 from './kun_loading70/index';
//KunLoading71组件
import KunLoading71 from './kun_loading71/index';
//KunLoading72组件
import KunLoading72 from './kun_loading72/index';
//KunLoading73组件
import KunLoading73 from './kun_loading73/index';
//KunLoading74组件
import KunLoading74 from './kun_loading74/index';
//KunLoading75组件
import KunLoading75 from './kun_loading75/index';
//KunLoading76组件
import KunLoading76 from './kun_loading76/index';
//KunLoading77组件
import KunLoading77 from './kun_loading77/index';
//KunLoading78组件
import KunLoading78 from './kun_loading78/index';
//KunLoading79组件
import KunLoading79 from './kun_loading79/index';
//KunLoading80组件
import KunLoading80 from './kun_loading80/index';
//KunLoading81组件
import KunLoading81 from './kun_loading81/index';
//KunLoading82组件
import KunLoading82 from './kun_loading82/index';
//KunLoading83组件
import KunLoading83 from './kun_loading83/index';
//KunLoading84组件
import KunLoading84 from './kun_loading84/index';
//KunLoading85组件
import KunLoading85 from './kun_loading85/index';
//KunLoading86组件
import KunLoading86 from './kun_loading86/index';
//KunLoading87组件
import KunLoading87 from './kun_loading87/index';
//KunLoading88组件
import KunLoading88 from './kun_loading88/index';
//KunLoading89组件
import KunLoading89 from './kun_loading89/index';
//KunLoading90组件
import KunLoading90 from './kun_loading90/index';
//KunLoading91组件
import KunLoading91 from './kun_loading91/index';
//KunLoading92组件
import KunLoading92 from './kun_loading92/index';
//KunLoading93组件
import KunLoading93 from './kun_loading93/index';
//KunLoading94组件
import KunLoading94 from './kun_loading94/index';
//KunLoading95组件
import KunLoading95 from './kun_loading95/index';
//KunLoading96组件
import KunLoading96 from './kun_loading96/index';
//KunLoading97组件
import KunLoading97 from './kun_loading97/index';
//KunLoading98组件
import KunLoading98 from './kun_loading98/index';
//KunLoading99组件
import KunLoading99 from './kun_loading99/index';
//KunLoading100组件
import KunLoading100 from './kun_loading100/index';
//KunLoading101组件
import KunLoading101 from './kun_loading101/index';
//KunLoading102组件
import KunLoading102 from './kun_loading102/index';
//KunLoading103组件
import KunLoading103 from './kun_loading103/index';
//KunLoading104组件
import KunLoading104 from './kun_loading104/index';
//KunLoading105组件
import KunLoading105 from './kun_loading105/index';
//KunLoading106组件
import KunLoading106 from './kun_loading106/index';
//KunLoading107组件
import KunLoading107 from './kun_loading107/index';
//KunLoading108组件
import KunLoading108 from './kun_loading108/index';
//KunLoading109组件
import KunLoading109 from './kun_loading109/index';
//KunLoading110组件
import KunLoading110 from './kun_loading110/index';
//KunLoading111组件
import KunLoading111 from './kun_loading111/index';
//KunLoading112组件
import KunLoading112 from './kun_loading112/index';
//KunLoading113组件
import KunLoading113 from './kun_loading113/index';
//KunLoading114组件
import KunLoading114 from './kun_loading114/index';
//KunLoading115组件
import KunLoading115 from './kun_loading115/index';
//KunLoading116组件
import KunLoading116 from './kun_loading116/index';
//KunLoading117组件
import KunLoading117 from './kun_loading117/index';
//KunLoading118组件
import KunLoading118 from './kun_loading118/index';
//KunLoading119组件
import KunLoading119 from './kun_loading119/index';


//存放组件的数组
const components = [
	KunLoading1,
	KunLoading2,
	KunLoading3,
	KunLoading4,
	KunLoading5,
	KunLoading6,
	KunLoading7,
	KunLoading8,
	KunLoading9,
	KunLoading10,
	KunLoading11,
	KunLoading12,
	KunLoading13,
	KunLoading14,
	KunLoading15,
	KunLoading16,
	KunLoading17,
	KunLoading18,
	KunLoading19,
	KunLoading20,
	KunLoading21,
	KunLoading22,
	KunLoading23,
	KunLoading24,
	KunLoading25,
	KunLoading26,
	KunLoading27,
	KunLoading28,
	KunLoading29,
	KunLoading30,
	KunLoading31,
	KunLoading32,
	KunLoading33,
	KunLoading34,
	KunLoading35,
	KunLoading36,
	KunLoading37,
	KunLoading38,
	KunLoading39,
	KunLoading40,
	KunLoading41,
	KunLoading42,
	KunLoading43,
	KunLoading44,
	KunLoading45,
	KunLoading46,
	KunLoading47,
	KunLoading48,
	KunLoading49,
	KunLoading50,
	KunLoading51,
	KunLoading52,
	KunLoading53,
	KunLoading54,
	KunLoading55,
	KunLoading56,
	KunLoading57,
	KunLoading58,
	KunLoading59,
	KunLoading60,
	KunLoading61,
	KunLoading62,
	KunLoading63,
	KunLoading64,
	KunLoading65,
	KunLoading66,
	KunLoading67,
	KunLoading68,
	KunLoading69,
	KunLoading70,
	KunLoading71,
	KunLoading72,
	KunLoading73,
	KunLoading74,
	KunLoading75,
	KunLoading76,
	KunLoading77,
	KunLoading78,
	KunLoading79,
	KunLoading80,
	KunLoading81,
	KunLoading82,
	KunLoading83,
	KunLoading84,
	KunLoading85,
	KunLoading86,
	KunLoading87,
	KunLoading88,
	KunLoading89,
	KunLoading90,
	KunLoading91,
	KunLoading92,
	KunLoading93,
	KunLoading94,
	KunLoading95,
	KunLoading96,
	KunLoading97,
	KunLoading98,
	KunLoading99,
	KunLoading100,
	KunLoading101,
	KunLoading102,
	KunLoading103,
	KunLoading104,
	KunLoading105,
	KunLoading106,
	KunLoading107,
	KunLoading108,
	KunLoading109,
	KunLoading110,
	KunLoading111,
	KunLoading112,
	KunLoading113,
	KunLoading114,
	KunLoading115,
	KunLoading116,
	KunLoading117,
	KunLoading118,
	KunLoading119,
]

//定义install方法，接收Vue作为参数。
const install = function (Vue) {
	//判断是否安装
	if (install.installed) return
	//遍历components数组，来进行全局注册
	components.map(component => {
		Vue.component(component.name, component)
	})
}

export default {
	install,
	KunLoading1,
	KunLoading2,
	KunLoading3,
	KunLoading4,
	KunLoading5,
	KunLoading6,
	KunLoading7,
	KunLoading8,
	KunLoading9,
	KunLoading10,
	KunLoading11,
	KunLoading12,
	KunLoading13,
	KunLoading14,
	KunLoading15,
	KunLoading16,
	KunLoading17,
	KunLoading18,
	KunLoading19,
	KunLoading20,
	KunLoading21,
	KunLoading22,
	KunLoading23,
	KunLoading24,
	KunLoading25,
	KunLoading26,
	KunLoading27,
	KunLoading28,
	KunLoading29,
	KunLoading30,
	KunLoading31,
	KunLoading32,
	KunLoading33,
	KunLoading34,
	KunLoading35,
	KunLoading36,
	KunLoading37,
	KunLoading38,
	KunLoading39,
	KunLoading40,
	KunLoading41,
	KunLoading42,
	KunLoading43,
	KunLoading44,
	KunLoading45,
	KunLoading46,
	KunLoading47,
	KunLoading48,
	KunLoading49,
	KunLoading50,
	KunLoading51,
	KunLoading52,
	KunLoading53,
	KunLoading54,
	KunLoading55,
	KunLoading56,
	KunLoading57,
	KunLoading58,
	KunLoading59,
	KunLoading60,
	KunLoading61,
	KunLoading62,
	KunLoading63,
	KunLoading64,
	KunLoading65,
	KunLoading66,
	KunLoading67,
	KunLoading68,
	KunLoading69,
	KunLoading70,
	KunLoading71,
	KunLoading72,
	KunLoading73,
	KunLoading74,
	KunLoading75,
	KunLoading76,
	KunLoading77,
	KunLoading78,
	KunLoading79,
	KunLoading80,
	KunLoading81,
	KunLoading82,
	KunLoading83,
	KunLoading84,
	KunLoading85,
	KunLoading86,
	KunLoading87,
	KunLoading88,
	KunLoading89,
	KunLoading90,
	KunLoading91,
	KunLoading92,
	KunLoading93,
	KunLoading94,
	KunLoading95,
	KunLoading96,
	KunLoading97,
	KunLoading98,
	KunLoading99,
	KunLoading100,
	KunLoading101,
	KunLoading102,
	KunLoading103,
	KunLoading104,
	KunLoading105,
	KunLoading106,
	KunLoading107,
	KunLoading108,
	KunLoading109,
	KunLoading110,
	KunLoading111,
	KunLoading112,
	KunLoading113,
	KunLoading114,
	KunLoading115,
	KunLoading116,
	KunLoading117,
	KunLoading118,
	KunLoading119,
}